import type { TowerWeightSchema } from "../types/project"

// Tower weight properties
export const TOWER_WEIGHT_PROPERTIES = [
  "Name",
  "Type",
  "Quantity",
  "MS Steel members",
  "HT Steel members",
  "MS Steel plates",
  "HT Steel plates",
  "16 dia B&N",
  "20 dia B&N",
  "Total",
]

/**
 * Gets all tower weight properties from the schema
 * @param schema The tower weight schema containing property definitions
 * @returns Array of property titles
 */
export const getAllTowerWeightProperties = (schema: TowerWeightSchema): string[] => {
  return TOWER_WEIGHT_PROPERTIES
}

